import socketIOClient from "socket.io-client";
import config from "./config";

export default socketIOClient(config.socket);